import React, { Suspense, useEffect } from "react";
import { useStore } from "react-redux";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { setDefaultTransformResponse } from "@coralblack/flax";
import { loadTheme } from "@fluentui/react";
import { AccessTokenAuthRoute } from "@layouts/AccessTokenAuth/AccessTokenAuthRoute";
import { EcoaLayout } from "@layouts/ecoa/Index";
import { HomeLayout } from "@layouts/home/Index";
import { LangContextProvider } from "@layouts/home/LangContext";
import { ErrorLayout } from "@pages/system/layout/Error";
import { RootState } from "maven-lib/dist/states";
import { classNames } from "maven-lib/dist/utils/misc";
import { dialogIfTokenDestroyedByNewToken } from "@maven-surface/components/common/auth/TokenInvalidDialog";
import { AuthRoute } from "@maven-surface/components/common/AuthRoute";
import "@maven-surface/assets/style/App.scss";
import "@coralblack/flax/dist/styles/index.css";

loadTheme({
  defaultFontStyle: { fontFamily: '"Nunito", "Noto Sans KR", sans-serif', fontWeight: "400" },
  fonts: {
    xSmall: {
      fontSize: "0.69rem",
    },
    small: {
      fontSize: "0.75rem",
    },
    medium: {
      fontSize: "0.82rem",
    },
    large: {
      fontSize: "0.91rem",
    },
    xLarge: {
      fontSize: "1rem",
    },
  },
});

function App() {
  const session = useStore<RootState>().getState().session;
  const appBadge = process.env.REACT_APP_BADGE;
  const appBadgeDisabled = process.env.REACT_APP_BADGE_DISABLE;

  useEffect(() => {
    document.body.classList.add("ready");

    setTimeout(() => {
      document.getElementById("spinner")?.remove();
    }, 1500);
  });

  setDefaultTransformResponse([
    function (data) {
      const o = JSON.parse(data);

      dialogIfTokenDestroyedByNewToken(o);

      return o;
    },
  ]);

  return (
    <BrowserRouter>
      <div className="app-hybrid-wrapper">
        {!appBadgeDisabled && appBadge && (
          <div className={classNames("notranslate app-sidebar-ribbon", `--${String(appBadge).toLowerCase()}`)}>{appBadge}</div>
        )}
        <Suspense
          fallback={
            <div className="suspense-loading">
              <div className="loading">
                <div className="loader" />
              </div>
            </div>
          }
        >
          <LangContextProvider>
            <Switch>
              <Route exact={true} path="/404" component={ErrorLayout} />
              <AccessTokenAuthRoute
                session={session}
                path={"/"}
                render={() => {
                  return (
                    <Switch>
                      <AuthRoute session={session} denyRedirectTo="/" path="/pat" component={EcoaLayout} />
                      <AuthRoute session={session} denyRedirectTo="/pat/visits" authorizedOnly={false} path="/" component={HomeLayout} />
                    </Switch>
                  );
                }}
              />
              <Redirect from="*" to="/404?r=rt" />
            </Switch>
          </LangContextProvider>
        </Suspense>
      </div>
    </BrowserRouter>
  );
}

export default App;
